/* eslint-disable no-undefined */
import useStyles from "./styles";
import { useState, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../Button";
import { Grid, Popover, Checkbox } from "@mui/material";
import SamplePDF from "../../assets/sample/studentimport.csv";
import { toast } from "react-toastify";

const BulkStudentImport = ({ createClick, isLoading, allowUnverified, setAllowUnverified }) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleCreate = () => {
    if (selectedFile) {
      createClick(selectedFile);
    } else {
      // eslint-disable-next-line no-alert
      toast.error("Please select a CSV file");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "email-validation-popover" : undefined;

  return (
    <>
      <div className={classes.pickercontainer}>
        <input ref={fileInputRef} onChange={handleFileChange} type="file" className={classes.picker} accept=".csv" />

        <div className={classes.uploadflex}>
          {/* <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div> */}
          <div>
            <h2 className={classes.uploadtitle}>Upload CSV</h2>
            <a className={classes.uploadsubtitle} download="sample_csv" href={SamplePDF} target="_blank" rel="noopener noreferrer">Download a sample csv file</a>
          </div>
        </div>
        {selectedFile && (
          <div className={classes.selectedfile}>
            <p>Selected file: <strong>{selectedFile.name}</strong></p>
            <Icon icon="line-md:minus-circle" onClick={handleRemoveFile} width="25" height="25" style={{ color: "#D42620" }} />
          </div>
        )}
      </div>
      <Grid container spacing={1}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className={classes.infoRow}>
            <span>Allow Import with Unverified Emails</span>
            <Icon
              icon="mdi:help-circle-outline"
              className={classes.helpIcon}
              onClick={handleInfoClick}
              width="20"
              height="20"
            />
          </div>

          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <Checkbox
              checked={allowUnverified}
              onChange={(e) => setAllowUnverified(e.target.checked)}
              color="primary"
            />
            <span className={classes.checkboxDesc}>
                      Check this box to continue the import without validation. Invalid or unreachable emails will be flagged in the import summary.
            </span>
          </div>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleInfoClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left"
            }}
            PaperProps={{
              style: { borderRadius: "12px" }
            }}
          >
            <div className={classes.popoverContent}>
              <div className={classes.popoverTitle}>Email Validation</div>
              <div className={classes.popoverText}>
                        We'll scan uploaded emails to ensure they're valid and belong to real domains. Invalid ones will be highlighted.
              </div>
              <Button
                className={classes.popoverBtn}
                onClick={handleInfoClose}
                variant="primary" buttonName="Got it" buttonSize="fluid" color="btndefault"
              />
            </div>
          </Popover>

        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className={classes.btn}>
            <Button variant="primary" buttonName="Create Batch Students" buttonSize="full" color="btndefault" onClick={handleCreate} isLoading={isLoading} />
          </div>
        </Grid>
      </Grid>
      {/* <ToastContainer /> */}
    </>
  );
};

export default BulkStudentImport;
